import { Link } from 'react-router-dom'
import Header from '../Component/Header'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MainSlider from '../Component/Slider'
import Footer from '../Component/Footer';
import Events from '../Component/Events';
import Menu from '../Component/Menu';
import PopUp from "../Component/Popup"
import OnlineRegistration from '../Component/OnlineRegistration'
import LazyLoad from 'react-lazyload';
const Home = () => {
    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        auto: true,
        slidesToScroll: 1
    };
    var settings1 = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        auto: true,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            }
        ]
    };
    const homeMenu = [
        { label: "Awards & Achievements", link: "/awardsAcheivements" },
        { label: "Gallery", link: "/Gallery", subMenu: [{ label: "Photo Gallery", link: "/Gallery" }, { label: "Video Gallery", link: "/VideoGallery" },] },

        {
            label: "Careers", link: "/careers-openings", subMenu: [
                { label: "Philosophy", link: "/philosophy" },
            ]
        },
        { label: "School Calendar", link: "/calender" },
        {
            label: "Alumni", link: "", subMenu: [
                { label: "Admissions", link: "/admission" },
                { label: "Admissions IIT", link: "/admissionIIT" },
            ]
        },

        { label: "eMagazine", link: "/magazine" },
        { label: "CUET", link: "https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/CUET.pdf" },
    ]
    return (
        <>
            <Header />
            <MainSlider />
            <PopUp />
            <Events />
            <Menu MenuItem={homeMenu} />
            <OnlineRegistration />
            <div class="virtual-tour">
                <a href="https://iviewd.com/lotus_valley_gurgaon/" target="_blank"  rel="noreferrer">
               <LazyLoad>    <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/virtual-tour.jpg" /></LazyLoad> 
                </a>
            </div>
            <div class="affiliation_number">
            Affiliation no - 531034

            </div>
            <div class="circular-tab1">
                <Link to="https://cbseacademic.nic.in/circulars.html" target="_blank" rel="noreferrer" >CBSE Circulars</Link>
            </div>
            <div class="circular-tab2">
                <Link to="/CBSEResult" target="_blank" rel="noreferrer" >CBSE Results 2023-24</Link>
            </div>
            <div class="regiter-merit2" id="regiter-merit1" >
                <a href="/howtoapply">Admission Opens 2026-27</a>
            </div>
            <div className='about padding-blk'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='about-blk'>
                                <h3>“Making a Difference to Education so that Education can make a Difference to the World.”</h3>
                                <p><b>‘Arise! Awake! and Stop not till the goal is reached’</b></p>
                                <p>We encourage our learners to discover their passion and decide their goals in life.</p>
                                <p>Education begins at home and I applaud the parents who recognize that they and not someone else - must take responsibility to assure that their children go to the best school</p>
                                <button className='explore'><Link to="/about"><i class="bi bi-box-arrow-in-right"></i> EXPLORE</Link></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='four-block padding-blk'>
                <div className='four_blk'>
                    <div>
                        <h3>“We help our learners discover who they really are and enable them to do what they love”</h3>
                        <button className='explore'><Link to="/primarywing"><i class="bi bi-box-arrow-in-right"></i> EXPLORE</Link></button>
                    </div>
                    <div>
                      <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/one-img.jpg" className='img-fluid' alt="lotus valley gurgaon" ></img></LazyLoad>
                    </div>
                    <div>
                       <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/two-img.jpg" className='img-fluid' alt="lotus valley gurgaon" ></img></LazyLoad>
                    </div>
                    <div>
                        <h3>“A stunning new-age design, is symbolic of our ethos, the modern approach we take to create the Joy of Learning”</h3>
                        <button className='explore'><Link to="/primarywing"><i class="bi bi-box-arrow-in-right"></i> EXPLORE</Link></button>
                    </div>

                </div>
            </div>
            <div className='padding-blk'>
                <div className='knowledge-blk'>
                    <h3>Knowledge is about going beyond textbooks, it perpetrates the Joy of Learning</h3>
                    <p>Lotus Valley International School makes a point of educating its learners beyond the regular curriculum. Our co-curricular activities edify them with learning in discipline, fitness, team spirit and confidence and help them develop a well-rounded personality.</p>
                  <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/hm-feed.jpg" alt="Lotus valley Gurgaon" className='img-fluid wid-100'></img></LazyLoad>
                    <button className='explore'><Link to=""><i class="bi bi-box-arrow-in-right"></i> EXPLORE</Link></button>
                </div>
            </div>
            <div className='social-feeds'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-xl-12'>
                            <h2>Social Feed</h2>
                        </div>
                        <div className='col-xl-4'>
                            <div class="fb-page" data-href="https://www.facebook.com/lotusvalleyinternationalschoolgurugram/" data-tabs="timeline" data-width="350" data-height="236" data-small-header="true" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true">
                                <blockquote cite="https://www.facebook.com/lotusvalleyinternationalschoolgurugram" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/lotusvalleyinternationalschoolgurugram/">Lotus Valley International School Gurgaon</a></blockquote>
                            </div>
                        </div>
                        <div className='col-xl-4'>
                            <Link to="https://www.youtube.com/@lotusvalleyinternationalsc7044" target='_blank'>
                               <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/youtube.jpg" className='img-fluid' alt="Lotus Valley Gurgaon" /></LazyLoad> 
                            </Link>
                        </div>
                        <div className='col-xl-4'>
                            <div className='anecdote'>
                                <h4>Parent's Anecdote</h4>
                                <i class="bi bi-quote"></i>
                                <Slider {...settings}>
                                    <div>
                                        <p>Why didn't we have school like this when we were young</p>
                                    </div>
                                    <div>
                                        <p>So happy my son is here and happy with how feedback is received and implemented. </p>
                                    </div>
                                    <div>
                                        <p>Fantastic! Congratulate you and your team! </p>
                                    </div>
                                    <div>
                                        <p>Any concern, any issue which is shared gets addressed.</p>
                                    </div>
                                    <div>
                                        <p>We are sure our children are in safe hands.</p>
                                    </div>
                                    <div>
                                        <p>I have been consistently happy and a satisfied parent ever since my partnership with the school as a parent.</p>
                                    </div>
                                    <div>
                                        <p>The school has a beautiful environment.</p>
                                    </div>
                                    <div>
                                        <p>There has been a visible and a very positive change in my ward ever since he joined LVIS</p>
                                    </div>
                                    <div>
                                        <p>Ma’am, your positivity is reflected as one enters the school premises.</p>
                                    </div>
                                    <div>
                                        <p>Ma’am, enough revisions done in class, if attentive in class the learners can appear for assessments with ease.</p>
                                    </div>
                                    <div>
                                        <p>“Ma’am, My daughter was shy and introvert but now her personality has changed she is much more confident and sociable.</p>
                                    </div>
                                    <div>
                                        <p>“My daughter has blossomed under the guidance of previous year and present class teacher.</p>
                                    </div>
                                    <div>
                                        <p>“My child has become responsible ever since she has joined school, she is keen to come to school every day.</p>
                                    </div>
                                    <div>
                                        <p>"The Quarterly E –Magazine is wonderful. I have read it cover to cover and the effort behind it is creditable.</p>
                                    </div>
                                    <div>
                                        <p>Happy with School’s beautiful infrastructure especially the basketball court.</p>
                                    </div>
                                    <div>
                                        <p>It’s my son’s fifth year in the school and I can see a remarkable change in my son’s personality and confidence.</p>
                                    </div>
                                    <div>
                                        <p> Awesome Presentation! Loved the complete participation of the class!" </p>
                                    </div>
                                    <div>
                                        <p>Kids are excited to attend the extra cricket classes….they look forward to the sessions with cricket sir." </p>
                                    </div>
                                    <div>
                                        <p>Appreciate the hard work of the teachers for taking classes even on Saturdays." </p>
                                    </div>
                                    <div>
                                        <p>The school authorities and teachers are very supportive.</p>
                                    </div>
                                    <div>
                                        <p>Regular messages from teachers and portal updates give a lot of help.</p>
                                    </div>
                                    <div>
                                        <p>Ma’am, your positivity is reflected as one enters the school premises.</p>
                                    </div>
                                    <div>
                                        <p>Ma’am, we appreciate and feel your love and positivity.</p>
                                    </div>
                                    <div>
                                        <p>I have been consistently happy and a satisfied since the last four-five years of my partnership with school as a parent.</p>
                                    </div>
                                    <div>
                                        <p>Encouragement and motivation given to our children helps them in increasing their confidence.</p>
                                    </div>
                                    <div>
                                        <p>We are very happy with the headmistress and the class teachers.</p>
                                    </div>
                                    <div>
                                        <p>Great coordination between parents and teachers,</p>
                                    </div>
                                </Slider>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div className='google-review padding-blk'>
                <div className='review-blk'>
                    <div className='col'>
                        <h4>Google Reviews</h4>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                    </div>
                    <div className='testimonial'>
                        <Slider {...settings1}>
                            <div class="tesimt-img-text"><div>
                                <p>The Sports Day event was absolutely fantastic! It filled our morning with so much joy and energy. The entire atmosphere was buzzing with excitement and enthusiasm. What struck me the most was how our mentors not only guided but actively participated, setting a great example for the students. It's incredible how their involvement doubled the students' zeal. I want to give a big shout out to the mentors, learners, and the entire team for another memorable event. They never cease to amaze the audience.</p>
                                <p><strong>Vaishali Sharma</strong></p></div>
                            </div>
                            <div class="tesimt-img-text"><div>
                                <p>It was a really great fun filled experience with all the kids. All the kids and teachers worked really hard to make the event a memorable one. Special thanks to Richa mam and Harpreet mam for their hard efforts….</p>
                                <p><strong>Disha Gera</strong></p></div>
                            </div>
                            <div class="tesimt-img-text"><div>
                                <p>Oh wow Janmashtami celebration. Was so beautiful and lovely. The entire atmosphere was so mesmerising. Totally loved the dance teachers thought the students . Lotus valley makes very occasion so special</p>
                                <p><strong>Neetika Bansal</strong></p></div>
                            </div>
                            <div class="tesimt-img-text"><div>
                                <p>Oh wow Janmashtami celebration. Was so beautiful and lovely. The entire atmosphere was so mesmerising. Totally loved the dance teachers thought the students . Lotus valley makes very occasion so special</p>
                                <p><strong>Neetika Bansal</strong></p></div>
                            </div>
                            <div class="tesimt-img-text"><div>
                                <p>Enrolling my child in Lotus Valley International School, Gurgaon has resulted in immense growth and development of my ward, and hence proven to be an excellent decision. The school provides a nourishing environment with an exploratory approach that lets each learner find themself. The hands-on involvement of the Principal and the Vice-Principal is quite reassuring as a parent.</p>
                                <p><strong>Manisha Balani</strong></p></div>
                            </div>
                            <div class="tesimt-img-text"><div>
                                <p>Sincere gratitude to the entire school management for organising the parents' workshop on innovative trails. It was an enlightening and enriching experience, and we as parents are truly grateful for the opportunity to participate. The workshop provided invaluable insights into innovative teaching methodologies and strategies, which I believe will greatly benefit both the school and the students. The speakers and facilitators demonstrated exceptional expertise and a genuine passion for their subjects, which made the sessions engaging and thought-provoking.<br />Thank you once again for your dedication and commitment to providing an outstanding educational experience for our children.</p>
                                <p><strong>Gaurav Manchanda</strong></p></div>
                            </div>
                            <div class="tesimt-img-text"><div>
                                <p>Respected Mentors,<br />It was indeed a very well planned Janmashtami event. The positive efforts of both Parul and Palak Ma'am reflected in the flawless performance of the little stars of Prep Primroses.<br />A very warm, welcoming and divine atmosphere was cherished by all the mother's during this fun- filled celebration. We love to be a part of such events. Thank you for hosting such events that builds our bonds stronger.<br />I would like to express my heartfelt gratitude towards Aashima Mallik ma'am, Ekta Ma'am, Ritu Ma'am and the epitome of knowledge our beloved Principal ma'am Ms. Anita Malhotra for providing in-depth understanding of festivals and important events in the most innovative ways for our little ones at such a tender age.<br />Looking forward for participating in such events in the near future.</p>
                                <p><strong>Simran Sethi</strong></p></div>
                            </div>
                            <div class="tesimt-img-text"><div>
                                <p>I am incredibly grateful for the profound impact LVISG has had on my life. Every aspect of the school radiated a commitment to excellence, from its nurturing environment to its dedicated teachers. The lessons I learned extended beyond textbooks, shaping my character and instilling values that guide me even today. Lifelong friendships were forged within its walls, and the memories created continue to bring warmth to my heart. My alma mater isn't just a school; it's a sanctuary of growth, a fountain of wisdom, and a testament to the transformative power of education.</p>
                                <p><strong>Dhruv Chauhan</strong></p></div>
                            </div>
                            <div class="tesimt-img-text"><div>
                                <p>We are so grateful to the school for imparting wholistic growth to our child. Academic with hands on experiences, equal importance to sports and ectra curriculum. On the occasion of 77th independence day celebration children presented their research on architecture, yoga, games, space, art and mathemtatics which was a learning for all. They sang and danced their hearts out. It was great effort put in by teachers and students alike. And a big kudos to parents as well.</p>
                                <p><strong>Namisha Bhan</strong></p></div>
                            </div>
                            <div class="tesimt-img-text"><div>
                                <p>Sincere gratitude towards team LVIS for organising Wow Dad event for all the father's. It was really a fun filled event with lots of activities and beautiful performances by our budding stars.<br />Kudos for the teachers and students for organising it so well.</p>
                                <p><strong>Ruchika Khanna</strong></p></div>
                            </div>
                        </Slider>
                    </div>
                </div>
                <div className='partners'>
                  <LazyLoad>  
                    <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/partner1.jpg" className='img-fluid' alt="Lotus Valley school gurgaon" />
                   <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/partner2.jpg" className='img-fluid' alt="Lotus Valley school gurgaon" />
                   <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/partner3.png" className='img-fluid' alt="Lotus Valley school gurgaon" />
                   <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/partner4.jpg" className='img-fluid' alt="Lotus Valley school gurgaon" /></LazyLoad>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default Home